var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 60,
    viewBox: "0 0 77 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 50.0252C74.1991 50.715 72.4666 50.0554 70.9126 47.7945L59.858 32.9778L58.2601 30.9262L45.3506 47.8438C43.8757 49.8792 42.3285 50.7643 39.5756 50.0442L56.1066 28.5461L40.7162 9.12711C43.3629 8.62861 45.1918 8.88205 46.8157 11.1787L58.2814 26.1801L69.8315 11.2604C71.311 9.22502 72.9021 8.45181 75.5586 9.20152L69.5912 16.8664L61.5062 27.0652C60.5435 28.2306 60.6758 29.0284 61.5617 30.1535L77 50.0252ZM0.019635 28.187L1.37157 21.7434C5.05314 8.99171 20.1404 3.69286 30.5452 11.572C36.6257 16.2062 38.137 22.7617 37.8362 30.1049H3.56145C3.0469 43.3226 12.8667 51.2997 25.3858 47.23C29.7771 45.8011 32.3638 42.4694 33.6585 38.3018C34.3157 36.2133 35.4026 35.8865 37.429 36.4835C36.3947 41.6962 34.0605 46.0506 29.1274 48.7759C21.7574 52.8551 11.2364 51.5358 5.70283 45.8666C2.40587 42.5768 1.04412 38.4092 0.433126 33.9519C0.336683 33.215 0.144375 32.5134 0 31.8074C0.012705 30.6011 0.019635 29.3954 0.019635 28.1892V28.187ZM3.62382 27.3013H34.597C34.3948 17.7437 28.2519 10.9549 19.8562 10.8973C10.6405 10.8274 4.02288 17.4544 3.62324 27.3013H3.62382Z",
    fill: "url(#paint0_linear_1159_2615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2615",
    x1: 0,
    y1: 29.5081,
    x2: 77,
    y2: 29.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.17fd55a0af9ed8547d6c45577ff391ba.svg";
export { ForwardRef as ReactComponent };